import { Asset as IAsset, ProductVariant} from "../../components/contracts/types";
import {numberToCurrency,imgpath} from "../../services/globals";
import { ProductAttribute } from "./ProductAttribute";
import PlaceCartComponent from '../../components/placecart'
import { stringify } from "querystring";
import Soffer from "../soffer";

export interface IProductAttr {
  key: string;
  values: Array<string>;
}

export default function ProductView ({ product, func }: { product: any; func?: any }) {
   const title = product.name;
  const description = product.description;
  //console.log(product.variants[0].priceWithTax);
  let soffer:boolean = false;
  //console.log("facets" + JSON.stringify(product.facetValues));
  const hasFacetId41 = (product.facetValues ?? []).some((facetValue: any) => {
    const facetId = Number(facetValue?.id);
    return facetId === 41 || facetId === 40;
  });

  if (hasFacetId41) {
    soffer = true;
  }
  const fprice = numberToCurrency(product.variants[0].priceWithTax);
  const imageAsset = product.assets?.[0];
  const img = imageAsset ? imgpath(imageAsset.source) : "";
  const imageWidth = imageAsset?.width ?? 800;
  const imageHeight = imageAsset?.height ?? 800;

  function handleSelect(select: string) {
    let id = (document.getElementById(select) as HTMLInputElement).value;
    let idnr:number = parseInt(id)
    let element = document.getElementsByClassName("incartbutton")[0]; //kommt auf der Detailseite nur einmal vor
    if (idnr > 0) {
      element.classList.remove("disabled");
    } else {
      element.classList.add("disabled");
    }
    
    //alert("changeSelect");
  }


  if (product.variantList.totalItems == 1) {
  return (
    <div className="row">
    <div className="col-md-7 product-detail">
        <img
          className="img-fluid img-thumbnail"
          src={img}
          alt={product.name}
          width={imageWidth}
          height={imageHeight}
          decoding="async"
          style={{ width: "100%", height: "auto", objectFit: "contain" }}
        />
        {soffer && <Soffer type="top"></Soffer>}
     </div> 
      <div className="col-md-5">
        <h3>{title}</h3> 
        
        <div dangerouslySetInnerHTML={{__html:description}}/>
         {soffer?<div className="price-box" >{fprice}</div> :
              <div >{fprice}</div>}
        <div> <PlaceCartComponent idnr={product.variants[0].id}  qty="1"  select={null}></PlaceCartComponent> </div>
        </div>
    </div>
  );
  } else {
    let index:number = 0;
    return (
      <div className="row">
    <div className="col-md-7">
        <img
          className="img-fluid img-thumbnail"
          src={img}
          alt={product.name}
          width={imageWidth}
          height={imageHeight}
          decoding="async"
          style={{ width: "100%", height: "auto", objectFit: "contain" }}
        />
     </div> 
      <div className="col-md-5">
        <div>{description}</div>
        <select id="selectvariants" onChange={() => {handleSelect("selectvariants");}}>
        <option value="0">Bitte auswählen</option>
        { 
          product.variants.map(function(vari,i) {
            //console.log(vari.priceWithTax);
            let fprice = numberToCurrency(vari.priceWithTax);
            return (<option value={vari.id} key={vari.id}>{vari.name} - {fprice}</option>)
        })  
        }
      </select>
      <div> <PlaceCartComponent  idnr="0"  qty="1"  select="selectvariants"></PlaceCartComponent> </div>
      </div>

      </div>

    );
  }
};
